import React, { useEffect, useState } from 'react';
import { settingsApi } from '../../api/settings';
import {
  formatAcceptNoteCheckLine,
  pricingFromCatalog,
} from '../../utils/estimateSceneWritingCost';
import { ACCEPT_INCLUDES_NOTE_CHECK } from '../../utils/writerCopy';

/**
 * Dollar line for the Note check on Accept.
 * Same band as Write draft, for this one call. Missing rates keep the
 * "what's included" sentence.
 */
export function acceptNoteCheckCostLine(noteFacts, pricing) {
  const cost = formatAcceptNoteCheckLine(noteFacts, pricing);
  return cost ? `${ACCEPT_INCLUDES_NOTE_CHECK} ${cost}` : ACCEPT_INCLUDES_NOTE_CHECK;
}

export default function AcceptNoteCheckCost({ noteFacts = null, onReady }) {
  const [pricing, setPricing] = useState(null);
  const modelId = (noteFacts?.model_id || noteFacts?.modelId || '').trim();
  const ready = Boolean(formatAcceptNoteCheckLine(noteFacts, pricing));

  useEffect(() => {
    onReady?.(ready);
    return () => onReady?.(false);
  }, [onReady, ready]);

  useEffect(() => {
    if (!modelId) {
      setPricing(null);
      return undefined;
    }
    let cancelled = false;
    settingsApi.getOpenRouterCatalog()
      .then((catalogRes) => {
        if (cancelled) return;
        const models = catalogRes?.data?.models || catalogRes?.models || [];
        setPricing(pricingFromCatalog(models, modelId));
      })
      .catch(() => {
        if (!cancelled) setPricing(null);
      });
    return () => { cancelled = true; };
  }, [modelId]);

  return (
    <span className="sw-why" data-testid="sw-accept-cost">
      {acceptNoteCheckCostLine(noteFacts, pricing)}
    </span>
  );
}
